module.exports = "<div class=\"maintenance-page\" fxLayout=\"column\" fxLayoutAlign=\"center center\">\n  <md-card class=\"maintenance-card\">\n    <md-card-header>Технічні роботи</md-card-header>\n    <md-card-content>\n      <p>{{message}}</p>\n      <p>Будь ласка, спробуйте пізніше.</p>\n    </md-card-content>\n  </md-card>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/maintenance/maintenance.component.html
// module id = ../../../../../src/app/maintenance/maintenance.component.html
// module chunks = 0